export default __webpack_public_path__ + "static/media/landing-page.ce6d441e.jpg";